import useFetch from '../../../hooks/useFetch';
import he from 'he';
import Share from './share';

import { Helmet } from 'react-helmet';

export default function BlogDetail(props) {
  const id = props.id;
  const { data: blog } = useFetch(`/blogs/${id}`, 'GET');

  return (
    <div className="mx-12 px-12 my-4 border-b-2 border-dashed border-black">
        {blog?.title ? (
          <>
            <Helmet>
              <meta name="title" content={blog.title} />
              <meta property="og:description" content={blog.description} />
            </Helmet>

            <article key={blog.id} className="text-center text-white">
              <h1 className="text-3xl md:text-5xl font-bold black-ops-font mb-2">{blog.title}</h1>
              <p className="text-sm md:text-base text-gray-400 mb-1">
                by {blog.author} | {blog.posted_on}
              </p>
              <div 
                  dangerouslySetInnerHTML={{ __html: he.decode(blog.content)
                    .replace(/<h1/g, '<h1 class="text-4xl font-bold mb-4"')
                    .replace(/<h2/g, '<h2 class="text-3xl font-bold mb-3"')
                    .replace(/<h3/g, '<h3 class="text-2xl font-bold mb-2"')
                    .replace(/<h4/g, '<h4 class="text-xl font-bold mb-2"')
                    .replace(/<h5/g, '<h5 class="text-lg font-bold mb-2"')
                    .replace(/<h6/g, '<h6 class="text-base font-bold mb-2"')
                  }}
                  className="text-left text-md md:text-xl space-y-8 leading-relaxed mt-12 mb-10"
              />
            </article>
            <Share />
          </>
        ) : (
          <div className='flex flex-col w-full items-center'>
            <h1 className="text-4xl black-ops-font text-blue-300">404 error: Blogpage not found!</h1>
            <p className="text-lg text-white mb-5">This blog is either nonexistent, unpublished, or is nonexistent!</p>
          </div>
        )}
    </div>
  )
}
